(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twd-size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function apply(root, option) {
      const dial = root.querySelector('[data-twd-dial]');
      const ring = root.querySelector('.twd-size__ring');
      const value = root.querySelector('[data-twd-value]');
      const title = root.querySelector('[data-twd-caption-title]');
      const text = root.querySelector('[data-twd-caption-text]');
      const link = root.querySelector('[data-twd-link]');
      if (!dial || !ring || !value) return;

      const mm = parseFloat(option.dataset.mm);
      const maxMm = parseFloat(root.dataset.maxMm) || mm;
      const label = option.dataset.label || '';
      const url = option.dataset.url || '';
      const linkText = option.dataset.linkText || '';

      root.querySelectorAll('[data-twd-size-option]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button === option));
      });

      // Scale the SVG, not the box — transform is compositor-driven, width is not
      ring.style.setProperty('--twd-scale', (mm / maxMm).toFixed(4));

      dial.classList.add('is-swapping');
      window.setTimeout(function () {
        value.textContent = option.dataset.mm;
        dial.classList.remove('is-swapping');
      }, 200);

      if (title) title.textContent = option.dataset.mm + ' mm \u00B7 ' + label;
      if (text) text.textContent = option.dataset.description || '';

      if (link) {
        if (url && linkText) {
          link.href = url;
          var arrow = document.documentElement.dir === 'rtl' ? '\u2190' : '\u2192';
          link.textContent = linkText + ' ' + arrow;
          link.hidden = false;
        } else {
          link.hidden = true;
        }
      }
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-twd-size]').forEach(function (root) {
        const first =
          root.querySelector('[data-twd-size-option][aria-pressed="true"]') ||
          root.querySelector('[data-twd-size-option]');
        if (first) apply(root, first);
      });
    }

    document.addEventListener('click', function (event) {
      const option = event.target.closest('[data-twd-size-option]');
      if (!option) return;
      const root = option.closest('[data-twd-size]');
      if (root) apply(root, option);
    });

    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
    if (document.readyState !== 'loading') init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
